import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import Button from "components/Buttons/Button/Button";
import Buttons from "components/Buttons/Buttons/Buttons";
import { currencyFormat } from "helpers/functions";
import Sitemap from "routes/sitemap";
import LoadingWrapper from "../../../components/Loading/LoadingWrapper";
import useAPI from "../../../hooks/useAPI";
import { GlobalQueries } from "../../../hooks/useRefreshQuery";
import ProfilePage from "../ProfilePage";
import scss from "./DebtPage.module.scss";
import { useTranslation } from "react-i18next";
import Empty from "components/Empty/Empty";

const DebtPage = () => {
    const { t } = useTranslation();
    const api = useAPI();
    const apiPath = "/profile/company/debt";

    // Load all data
    const { data, isLoading } = useQuery([GlobalQueries.Profile.MyProfile], () => api.get(apiPath));

    const { data: config } = useQuery(["debtConfig"], () => api.get("/options/profile-page/company-analytics-data/config"));

    // Local state for the debt
    const [debt, setDebt] = useState();
    useEffect(() => {
        setDebt(data);
    }, [data, setDebt]);

    return (
        <ProfilePage>
            <h4 className="h-underline">{t("debt_profile-default-title")}</h4>
            {config && config?.active !== "1" && <Empty message={t("global-module_locked-title")} />}

            <LoadingWrapper isLoading={isLoading}>
                {debt && config?.active === "1" && (
                    <div>
                        <h5 className={scss.subtitle}>{t("debt_profile-default-subtitle")}:</h5>
                        <div className={scss.debt}>
                            <div className={scss.debtSection}>
                                <p className={scss.debtTitle}>{debt.debt_days ?? 0}</p>
                                <p className={scss.debtSubtitle}>{t("debt_profile-default-days")}</p>
                                <p className={scss.debtDescription}>{t("debt_profile-default-Currency")}</p>
                            </div>
                            <span className={scss.divider} />
                            <div className={scss.debtSection}>
                                <p className={scss.debtTitle}>{currencyFormat(debt.credit_limit, "", false) ?? 0}</p>
                                <p className={scss.debtSubtitle}>RSD</p>
                                <p className={scss.debtDescription}>{t("debt_profile-default-credit_limit")}</p>
                            </div>
                        </div>
                        <p className={`${scss.question} ${scss.questionTitle}`}>{t("debt_profile-default-question")}</p>
                        <p className={scss.question}>{t("debt_profile-default-contact_us_text")}</p>
                        <Buttons>
                            <Button label={t("debt_profile-default-contact_us_button")} to={Sitemap.contact._} />
                        </Buttons>
                    </div>
                )}
            </LoadingWrapper>
        </ProfilePage>
    );
};

export default DebtPage;
